import React, { useState } from "react";
import "./EstimateDeliveryComponent.css";
import YellowFilledRoundBtn from "../../../Common-Component/Common_Btn/YellowFilledRoundBtn/YellowFilledRoundBtn";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import OrangeFilledRoundBtn from "../../../Common-Component/Common_Btn/OrangeFilledRoundBtn/OrangeFilledRoundBtn";
import UploadFileModal from "../../../Common-Component/Common_Modal/UploadFileModal/UploadFileModal";
import { useDispatch } from "react-redux";
import { pincodeCheck } from "../../../../features/products/productsSlice";

const EstimateDeliveryComponent = ({product,combination}) => {
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const [showUploadModal, setshowUploadModal] = useState(false);
  const dispatch = useDispatch();
  const onSubmit = async (data) => {
    // if()
    data.product_id=product.id;
    const res = await dispatch(pincodeCheck(data));
    if (res?.payload?.errors) {
        setError("pincode", {
            type: "manual",
            message: res.payload?.errors,
          });
      }else{
        setshowUploadModal(true);
      }

    // if (res.meta?.requestStatus === "fulfilled") {
     
    //   if(res.payload?.errors){ setError("pincode", {
    //     type: "manual",
    //     message: res.payload?.errors,
    //   });

    //   }
    // } else if (res.meta?.requestStatus === "rejected") {
    
        // setError("pincode", {
        //   type: "manual",
        //   message: res.payload?.errors,
        // });
      
    // }
  };

  
  return (
    <section className="EstimateDeliveryComponent">
      <div className="row mb-3">
        <div className="col-lg-6  col-md-6 col-sm-6  col-6">
          <p className="extimate_text">Estimate Delivery</p>
        </div>

        {/* <div className='col-lg-6 col-md-6 col-sm-6 col-6'>
                    <div className='create_file_btn'>
                        <YellowFilledRoundBtn btnText='Create Your Files' />
                    </div>
                </div> */}
      </div>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-lg-6  col-md-6 col-sm-6  col-6">
            <div className="pincode_div">
              <Form.Control
                type="text"
                name="pincode"
                placeholder="Enter Pincode"
                {...register("pincode", {
                  required: "Pincode is required",
                })}
                className={classNames("", {
                  "is-valid": getValues("pincode"),
                })}
              />
              {errors?.pincode && (
                <sup className="text-danger">{errors?.pincode?.message}</sup>
              )}
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-6 col-6">
            <div
              className="upload_file_btn"
            //   onClick={() => {
            //     setshowUploadModal(true);
            //   }}
            >
              <OrangeFilledRoundBtn btnText="Upload Your Files" type={'submit'} />
            </div>
          </div>
        </div>
      </Form>

      <UploadFileModal
      product={product}
      combination={combination}
        onHide={() => setshowUploadModal(false)}
        show={showUploadModal}
        checkOutProcessBaseLink={"/cart-process"}
      />
    </section>
  );
};

export default EstimateDeliveryComponent;
